// Shared timestamp format for the sub-trade documents table (LOS-6471):
// YYYY/MM/DD H:MM AM/PM (e.g. 2026/06/03 2:45 PM). Used by the Delivery column
// and by the C / AA / FM / AL status lines so they cannot drift apart.
export const formatDocumentTimestamp = (iso: string): string => {
  const d = new Date(iso)
  if (isNaN(d.getTime())) return ''
  const yyyy = d.getFullYear()
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const dd = String(d.getDate()).padStart(2, '0')
  const ampm = d.getHours() >= 12 ? 'PM' : 'AM'
  const h = d.getHours() % 12 || 12
  const min = String(d.getMinutes()).padStart(2, '0')
  return `${yyyy}/${mm}/${dd} ${h}:${min} ${ampm}`
}
